angular.module('tgaAdmin')
  .controller('FooterController', [
    '$scope', 'settingsService',
    function (
      $scope, settingsService,
    ) {
      $scope.data = {
        affiliate: null,
      };

      $scope.initialize = function () {
        settingsService.getSettings().then(
          (settings) => {
            if (settings.affiliate_logo) {
              $scope.data.affiliate = settings.affiliate_logo;
            }
          },
        );
      };
      $scope.initialize();
    },
  ]);
